import { Controller } from "@hotwired/stimulus"

// Auto-rotates the homepage hero through the featured-surgeon slides set in
// Admin > Surgeons > Homepage Hero Carousel.
export default class extends Controller {
  static targets = ["slide", "dot"]
  static values = { interval: { type: Number, default: 6000 } }

  connect() {
    this.index = 0
    this.timer = setInterval(() => this.next(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  next() {
    this.show((this.index + 1) % this.slideTargets.length)
    this.resetTimer()
  }

  prev() {
    this.show((this.index - 1 + this.slideTargets.length) % this.slideTargets.length)
    this.resetTimer()
  }

  goTo(event) {
    this.show(parseInt(event.currentTarget.dataset.index, 10))
    this.resetTimer()
  }

  resetTimer() {
    clearInterval(this.timer)
    this.timer = setInterval(() => this.show((this.index + 1) % this.slideTargets.length), this.intervalValue)
  }

  show(newIndex) {
    this.slideTargets[this.index]?.classList.add("hidden")
    this.dotTargets[this.index]?.classList.replace("bg-white", "bg-white/40")
    this.index = newIndex
    this.slideTargets[this.index]?.classList.remove("hidden")
    this.dotTargets[this.index]?.classList.replace("bg-white/40", "bg-white")
  }
}
